import SkillTag from './SkillTag';

export default function SkillTagList({ skills }) {
  return (
    <div className="flex flex-wrap gap-3 justify-center">
      {skills.map((skill, index) => (
        <SkillTag key={index} skill={skill} />
      ))}
    </div>
  );
}